import styled from "styled-components";
import ThemeColors from "../../../../../../../../themes/colors";

export const PostCard = styled.div<{ color: string; isBack?: boolean }>`
  background-color: ${(props) => props.color};
  opacity: ${(props) => (props.isBack ? "0.7" : 1)};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28rem;
  gap: 2rem;
  width: 18rem;
  flex-direction: column;
  border-radius: 1.5rem;
  padding: 1rem 0.75rem;
  font-size: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: grab;
  justify-content: flex-start;
`;

export const CardButton = styled.div<{ customColor?: string }>`
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: ${(props) =>
    props.customColor ? props.customColor : ThemeColors.Bg300};
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    !props.customColor &&
    `
  
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
  `}
`;
